export const GET_METHOD = 'GET';
export const POST_METHOD = 'POST';

export async function postData(url, data) {
    const response = await fetch(url, {
        method: POST_METHOD,
        body: JSON.stringify(data),
    });

    return response.json();
}
